/// <amd-module name="VSSUI/Components/ItemIndicator/Item" />
import { IObservable, Observable } from "VSS/Core/Observable";
import { IIconProps } from "VSSUI/Icon";

export const ITEM_CHANGE_EVENT = "item-changed";

export interface IItemState {
    /**
     * The value to display for this item's indicator. Typically presented as a tooltip on the indicator.
     */
    title: string;

    /*
     * Icon that represents the state of the indicator for this item.
     */
    iconProps?: IIconProps;

    /**
     * Whether the indicator is active or not, in case it's a toggle.
     * Use undefined to omit the attribute aria-pressed.
     */
    isPressed?: boolean;
}

export interface IItem extends IObservable<IItemState> {
    /**
     * Gets the current state of the item.
     */
    getState: () => IItemState;

    /**
     * Sets a new state for the item.
     * @param state New item state.
     * @param supressChangeEvent If true, don't invoke changed callback at this time.
     */
    setState(state: IItemState, suppressChangeEvent?: boolean): void;
}

export interface IItemProps {
    /**
     * Initial state of the item.
     */
    initialState: IItemState;
}

export class Item extends Observable<IItemState> implements IItem {
    private _currentState: IItemState;
    constructor(props: IItemProps) {
        super();
        this._currentState = { ...props.initialState };
    }

    /**
     * Gets the current state of the item.
     */
    public getState(): IItemState {
        return this._currentState;
    }

    /**
     * Sets a new state for the item.
     * @param state New item state.
     * @param supressChangeEvent If true, don't invoke changed callback at this time.
     */
    public setState(state: IItemState, supressChangeEvent: boolean = false): void {
        this._currentState = state;
        if (!supressChangeEvent) {
            this.notify(state, ITEM_CHANGE_EVENT);
        }
    }
}